import styled, { css } from 'styled-components';

import LoyaltyPointsIcon from 'components/icons/loyalty-points-icon';
import Picture from 'components/picture';
import { ProgressMeter } from 'components/progress-meter';
import { StyledBlockRenderer } from 'pages/loyalty/loyalty-offers/loyalty-offers.styled';
import { primitive } from 'styles/constants/primitives';
import { fadeIn } from 'utils/style/animations';

import { RewardLock } from '../../reward-lock';
import { HIGHLIGHT_COLOR } from '../constants';
import { RewardLockIcon } from '../reward-lock-icon';

export const REWARD_CARD_HEIGHT = 8.25;

export const RewardText = styled.h3`
  font-size: 1rem;
  font-family: ${Styles.fontFamily.brand};
  font-weight: ${Styles.fontWeight.normal};
  text-transform: capitalize;
  letter-spacing: normal;
  line-height: 1.25;
  margin: 0 0 0.25rem 0;
`;

export const BackgroundImage = styled(Picture)`
  width: 100%;
  height: 100%;
  position: absolute;
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: 9.375rem;
  height: 6.25rem;
  flex-shrink: 0;
  z-index: ${Styles.zIndex.below};
  ${Styles.mobileTiny`
    width: 7rem;
  `};
`;

export const StyledProgressMeter = styled(ProgressMeter)`
  border: 0;
  background: white;
  width: 95%;
  margin: 0.25rem 0;
  ${Styles.desktop`
    width: 80%
  `}
`;

export const StyledRewardPoints = styled.p`
  font-size: 1rem;
  margin: 0.25rem 0 0;
  text-transform: lowercase;
  strong {
    font-weight: ${Styles.fontWeight.heavy};
    color: ${Styles.color.primary};
  }
`;

export const CardContainer = styled.li`
  height: ${`${REWARD_CARD_HEIGHT}rem`};
  width: 100%;
  padding: 0;
  background: ${primitive.$white};
`;

export const StyledClickableContainer = styled.button<{ isLocked: boolean }>`
  /* reset button styles */
  border: none;
  text-align: left;
  background: ${primitive.$white};
  display: flex;

  width: 100%;
  height: 100%;
  opacity: 0;
  animation: ${fadeIn} 0.4s forwards;
  border-bottom: 1px solid ${Styles.color.grey.four};
  padding: 1rem;
  cursor: pointer;
  position: relative;
  z-index: ${Styles.zIndex.normal};
  ${StyledRewardPoints} {
    strong {
      ${p =>
        p.isLocked &&
        css`
          color: ${Styles.color.grey.three};
        `}
    }
  }
  ${ImageWrapper} {
    img {
      ${p =>
        p.isLocked &&
        css`
          opacity: 0.5;
        `}
    }
  }
`;

export const Overlay = styled.div`
  opacity: 0.275;
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: ${Styles.zIndex.normal};
  background-color: ${Styles.color.grey.three};
`;

export const InfoContainer = styled.div`
  margin-left: 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
`;

export const PointsNeededContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const PointsNeededText = styled.p`
  font-size: 0.8125rem;
  margin: 0;

  ${Styles.desktop`
    font-size: 1rem;
  `}

  span {
    color: ${Styles.color.primary};
  }
`;

export const StyledLockIcon = styled(RewardLockIcon)`
  & > div {
    top: 3px;
    transform: scale(0.4);
  }
`;

export const PointTextContainer = styled.div`
  display: flex;
  align-items: center;
  line-height: 1.25;
`;

export const StyledPointsIcon = styled(LoyaltyPointsIcon)`
  margin-right: 0.25em;
`;

export const HighlightedPointsIcon = styled(StyledPointsIcon)`
  path {
    fill: ${HIGHLIGHT_COLOR};
  }
`;

export const StyledUnLockedRewardPoints = styled.div`
  display: none;
`;

export const StyledRewardLock = styled(RewardLock)`
  > div {
    background-color: ${Styles.color.tertiary};
    ::before,
    ::after {
      border-color: ${Styles.color.tertiary};
    }
    ::after {
      background-color: inherit;
    }
  }
`;

export const PointsNeededLockIcon = styled(StyledRewardLock)`
  transform: scale(0.4);
  position: relative;
  width: 1.2rem;
  height: 1.2rem;
  margin: 0 0.25rem 0 0;
  display: none;
  > div {
    background-color: ${HIGHLIGHT_COLOR};
    ::before,
    ::after {
      border-color: ${HIGHLIGHT_COLOR};
    }
    ::after {
      background-color: inherit;
    }
  }
`;

export const IncentiveCardDescription = styled(StyledBlockRenderer)`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
`;
